import { Grid } from '@mui/material'
import { AuthLayout, Text } from 'components'
import { WELCOME_DESCRIPTION, WELCOME_TITLE } from 'config'
import { AuthMain, AuthWrapper } from '../SignIn'
import { Form } from './component'
import { color } from 'config/color'

interface IAuthTitle {
  title: string
}

const AuthTitle = ({ title }: IAuthTitle): JSX.Element => {
  return (
    <Text color={color.grey[900]} fontSize="24px" fontWeight="600" margin="0 0 24px">
      {title}
    </Text>
  )
}

export const ForgotPassword: React.FC = () => {
  return (
    <AuthLayout
      title={WELCOME_TITLE}
      desc={WELCOME_DESCRIPTION}
      isAuthPage={true}

    >
      <AuthWrapper isAuthPage={true}>
        <Grid mb={5} container justifyContent={'center'}>
          <Grid item xs={12} md={6}>
            <AuthMain isRounded={true}>
              <AuthTitle title="Reset Password" />
              <Form />
            </AuthMain>
          </Grid>
        </Grid>
      </AuthWrapper>
    </AuthLayout>
  )
}
